
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { IProject } from '@/api/types'
import EmptyState from '@/components/Empty/EmptyState.vue'

@Component({
  components: {
    EmptyState
  }
})
export default class UserProjectsCard extends Vue {

  public get projects(): IProject[] {
    console.log('项目信息:', UserModule.projects)
    return UserModule.projects || []
  }

  // 处理项目点击事件
  public handleProjectClick(project: IProject) {
    // console.log('项目被点击:', project)
    // 预留跳转逻辑，后续实现
    // this.$router.push({ path: `/project/${project.id}` })
  }
}
